import React from "react";
import {css, cx} from "@panda/css";

import {CloseIcon} from "@pg-design/icons-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {DesktopText} from "../../../atoms/typography/DesktopText";

interface IProps {
    className?: string;
    children: string;
    onClose: (event: React.MouseEvent) => void;
    show?: boolean;
    truncateLine?: number;
    fullHeight?: boolean;
}

export const OfferToggleDescription = (props: IProps) => {
    const description = props.children.replace(/[\r\n]+/g, " ").slice(0, 400);

    return (
        <div
            className={cx(
                descriptionBaseStyle,
                props.show ? descriptionVisibleStyle : descriptionHiddenStyle,
                props.fullHeight ? fullHeightStyle : defaultHeightStyle,
                props.className
            )}
            style={{"--truncate-lines": props.truncateLine || 7} as React.CSSProperties}
            data-testid={OFFER_TEST_IDS.LISTING_OFFER_BOX.PROPERTY_DESCRIPTION}
        >
            <div className={closeIconWrapperStyle} onClick={props.onClose}>
                <CloseIcon size="2" />
            </div>

            <DesktopText variant="info_txt_1">{description.slice(0, description.lastIndexOf(" ")).trim()}</DesktopText>
        </div>
    );
};

const descriptionBaseStyle = css({
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: 2,
    backgroundColor: "var(--colors-white)",
    pt: 2,
    pr: 4.5,
    pb: 1.5,
    pl: 1,
    height: "100%",
    overflow: "hidden"
});

const descriptionHiddenStyle = css({
    display: "none"
});

const descriptionVisibleStyle = css({
    lineClamp: "var(--truncate-lines)",
    textOverflow: "ellipsis",
    whiteSpace: "normal"
});

const defaultHeightStyle = css({
    maxHeight: "calc(100% - 1.2rem)"
});

const fullHeightStyle = css({
    maxHeight: "100%"
});

const closeIconWrapperStyle = css({
    position: "absolute",
    top: 2,
    right: 1,
    cursor: "pointer"
});
import React from "react";
import {css, cx} from "@panda/css";

import {CloseIcon} from "@pg-design/icons-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {DesktopText} from "../../../atoms/typography/DesktopText";

interface IProps {
    className?: string;
    children: string;
    onClose: (event: React.MouseEvent) => void;
    show?: boolean;
    truncateLine?: number;
    fullHeight?: boolean;
}

export const OfferToggleDescription = (props: IProps) => {
    const description = props.children.replace(/[\r\n]+/g, " ").slice(0, 400);

    return (
        <div
            className={cx(
                descriptionBaseStyle,
                props.show ? descriptionVisibleStyle : descriptionHiddenStyle,
                props.fullHeight ? fullHeightStyle : defaultHeightStyle,
                props.className
            )}
            style={{"--truncate-lines": props.truncateLine || 7} as React.CSSProperties}
            data-testid={OFFER_TEST_IDS.LISTING_OFFER_BOX.PROPERTY_DESCRIPTION}
        >
            <div className={closeIconWrapperStyle} onClick={props.onClose}>
                <CloseIcon size="2" />
            </div>

            <DesktopText variant="info_txt_1">{description.slice(0, description.lastIndexOf(" ")).trim()}</DesktopText>
        </div>
    );
};

const descriptionBaseStyle = css({
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: 2,
    backgroundColor: "var(--colors-white)",
    pt: 2,
    pr: 4.5,
    pb: 1.5,
    pl: 1,
    height: "100%",
    overflow: "hidden"
});

const descriptionHiddenStyle = css({
    display: "none"
});

const descriptionVisibleStyle = css({
    lineClamp: "var(--truncate-lines)",
    textOverflow: "ellipsis",
    whiteSpace: "normal"
});

const defaultHeightStyle = css({
    maxHeight: "calc(100% - 1.2rem)"
});

const fullHeightStyle = css({
    maxHeight: "100%"
});

const closeIconWrapperStyle = css({
    position: "absolute",
    top: 2,
    right: 1,
    cursor: "pointer"
});
